import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

const Meta = () => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = "Unicon Catalogues – Explore Our Full Product Range"; // Reset title if necessary
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return (
    <Helmet>
      <title>Unicon Catalogues – Explore Our Full Product Range</title>
      <meta
        name="title"
        content="Unicon Catalogues – Explore Our Full Product Range"
      />
      <meta
        name="description"
        content="Browse Unicon's catalogues to explore our comprehensive selection of industrial solutions, including air pollution control, material handling, and more."
      />
      <meta name="keywords" content="Unicon Catalogues" />
      <meta name="robots" content="index,follow" />
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta
        property="og:title"
        content="Unicon Catalogues – Explore Our Full Product Range"
      />
      <meta property="og:site_name" content="Unicon Catalogues" />
      <meta property="og:url" content="https://www.uniconinter.com/products" />
      <meta
        property="og:description"
        content="Browse Unicon's catalogues to explore our comprehensive selection of industrial solutions, including air pollution control, material handling, and more."
      />
      <meta property="og:type" content="product" />
      <meta
        property="og:image"
        content="https://www.uniconinter.com/images/products/products-list/video-thumb.jpg"
      />
    </Helmet>
  );
};

export default Meta;
